class Config {
  [key: string]: string | boolean | object;

  public diil: {
    [key: string]: string | boolean | object;

    facebookUrl?: string;
    selfServiceUrl?: string;
    selfServiceUrlRu?: string;
    webUrl?: string;
    roamingDayPackageTermsEst: string;
    roamingDayPackageTermsRus: string;
    volumesPageInSelfService: string;
  };
  public super: {
    [key: string]: string | boolean | object;

    facebookUrl?: string;
    selfServiceUrl?: string;
    selfServiceUrlRu?: string;
    webUrl?: string;
    instagramUrl: string;
    tiktokUrl: string;
    selfServiceUrlEn: string;
  };
  public apiUrl: string;
  public apiBaseUrl: string;
  public cachingEnabled: boolean;
  public commonApiUrl: string;
  public enableLabelStatistics: boolean;
  public environment: 'local' | 'ui-test' | 'dev' | 'test' | 'live';
  public devHostAliasNames?: string[];
  public credentialsAllowed: boolean;

  public initialized = false;

  public initialize(config: InitialConfig) {
    if (this.initialized) {
      console.warn('WARNING, Configuration already initialized!');
    }
    Object.keys(config).forEach((key) => {
      this[key] = config[key];
    });
    this.initialized = true;
  }
}

export default new Config();
